module.exports = __webpack_public_path__ + "static/media/basis-share-logo.466cf09b.svg";